<div class="container">
  <router-outlet (activate)="setLoadingFinished()"></router-outlet>
</div>